var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"data-loader"}},[(_vm.isLoading)?_c('div',[_vm._t("loading",function(){return [_vm._m(0)]}),_vm._v(" "),_c('loading-bar')],2):_vm._t("default")],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticStyle:{"text-align":"center"}},[_c('em',[_vm._v("\n          The test simulation is loading...\n        ")])])
}]

export { render, staticRenderFns }